import _ from 'lodash';
import { HsTableServiceSymbol } from '@/services/HsTableService';
import { injectService } from '@/inversify.config';
export function useReloadTableData({ hsTableInstance, data, } = {}) {
    const hsTableService = injectService(HsTableServiceSymbol);
    const instance = hsTableInstance || hsTableService.hsInstance;
    const newData = data || _.get(hsTableService, 'hsSettings.data');
    if (instance && instance.loadData && newData) {
        instance.loadData(newData);
    }
}
